<template>
	<el-carousel height="250px" indicator-position="outside">
		<el-carousel-item v-for="(img, i) in images.items" :key="i">
			<img :src="img" alt="" />
		</el-carousel-item>
	</el-carousel>
</template>

<script>
import { Carousel, CarouselItem } from "element-ui"

export default {
	components: {
		ElCarousel: Carousel,
		ElCarouselItem: CarouselItem,
	},
	props: {
		images: {
			type: Object,
			default: () => {},
		},
	},
}
</script>

<style lang="scss" scoped></style>
